module.exports = __webpack_public_path__ + "static/Water_Weird-533463cdd76d03e88f3bb6a594e508e1.jpg";